var Enum = Enum || {};

Enum.ERROR_CODE = {
	PASSWORD_POLICY_VIOLATION: 'PASSWORD_POLICY_VIOLATION',
	DUPLICATED_USER_LOGIN: 'DUPLICATED_USER_LOGIN',
	DUPLICATED_USER_EMAIL: 'DUPLICATED_USER_EMAIL',
	DUPLICATED_USER_PESEL: 'DUPLICATED_USER_PESEL',
	DUPLICATED_USER_PRIMARY_PHONE: 'DUPLICATED_USER_PRIMARY_PHONE',
	DUPLICATED_USER_SECONDARY_PHONE: 'DUPLICATED_USER_SECONDARY_PHONE',
	DUPLICATED_DOCTOR_PWZ: 'DUPLICATED_DOCTOR_PWZ',
	DUPLICATED_CLINIC_NAME: 'DUPLICATED_CLINIC_NAME',
	DUPLICATED_CLINIC_REGON: 'DUPLICATED_CLINIC_REGON',
	DUPLICATED_CLINIC_NIP: 'DUPLICATED_CLINIC_NIP',
    LOGIN_ALREADY_EXISTS: 'LOGIN_ALREADY_EXISTS',
    INCORRECT_OLD_PASSWORD: 'INCORRECT_OLD_PASSWORD'
};

Object.freeze(Enum.ERROR_CODE);